import Vue from 'vue';
const NewsletterModalComponent = () => import(/* webpackChunkName: "newsletterModal" */ '../components/shared/newsletter-modal-component.vue');

const newsletterModal = (() => {
    const SELECTOR = '.js-page-head__newsletter';

    class NewsletterModal {
        constructor(element) {
            this.mounted = false;
            this.element = element;
            element.addEventListener('click', this.handleClick.bind(this));
        }

        createComponent() {
            const _this = this;

            const vm = new Vue({
                render(h) {
                    const _vm = this;

                    return h(NewsletterModalComponent, {
                        props: {
                            show: _vm.show,
                        },
                        on: {
                            close() {
                                _vm.show = false;
                            },
                        }
                    });
                },
                data: {
                    show: false
                }
            });

            return vm;
        }

        mountComponent() {
            this.mounted = true;
            this.el = this.createDomElement();
            this.vm = this.createComponent();
            this.vm.$mount(this.el);
        }


        createDomElement() {
            const element = document.createElement('div');
            document.body.appendChild(element);

            return element;
        }

        handleClick(e) {
            e.preventDefault();
            !this.mounted && this.mountComponent();
            this.vm.show = !this.vm.show;
        }
    }

    [].slice.call(document.querySelectorAll(SELECTOR)).forEach(item => {
        return new NewsletterModal(item);
    });
})();

export default newsletterModal;
